import { FC, RefObject } from "react";
import DetectorWrapper from "./detector";
import React, { Component } from "react";

type Props = {
  detectionCanvasRef: RefObject<HTMLCanvasElement>;
  captureCanvasRef: RefObject<HTMLCanvasElement>;
  frameDivRef: RefObject<HTMLDivElement>;
  videoRefBg: RefObject<HTMLVideoElement>;
  frameDivDimensions: DOMRect | null;
  videoHeight: number;
  videoWidth: number;
};

const ScanCanvas: FC<Props> = ({
  detectionCanvasRef,
  captureCanvasRef,
  videoRefBg,
  frameDivRef,
  frameDivDimensions,
  videoHeight,
  videoWidth,
}) => {
  const getWidth = () => {
    const scaleX =
      (videoRefBg.current?.videoWidth || 0) /
      (videoRefBg.current?.clientWidth || 1);

    if (frameDivRef.current) {
      const frameDivRefDimensions = frameDivRef.current.getBoundingClientRect();
      return Math.round(frameDivRefDimensions.width * scaleX);
    } else if (frameDivDimensions) {
      return Math.round(frameDivDimensions.width * scaleX);
    }
    return 500;
  };

  const getHeight = () => {
    const scaleY =
      (videoRefBg.current?.videoHeight || 0) /
      (videoRefBg.current?.clientHeight || 1);
    if (frameDivRef.current) {
      const frameDivRefDimensions = frameDivRef.current.getBoundingClientRect();
      return Math.round(frameDivRefDimensions.height * scaleY);
    } else if (frameDivDimensions) {
      return Math.round(frameDivDimensions.height * scaleY);
    }
    return 500;
  };

  return (
    <>
      <canvas
        className="detectionCanvas"
        width={DetectorWrapper.image_size}
        height={DetectorWrapper.image_size}
        ref={detectionCanvasRef}
        style={{ display: "none" }}
      />
      <canvas
        className="captureCanvas"
        width={videoWidth}
        height={videoHeight}
        ref={captureCanvasRef}
        style={{ display: "none" }}
      />
    </>
  );
};

export default ScanCanvas;
